// Eventi del check-up finanziario.
// Convenzione del sito: si pusha nel dataLayer, GTM inoltra a GA4 (vedi trackedLinks.js).
// Nessun dato finanziario o personale negli eventi: solo contatori, punteggio e livello.

// L'ordine deve seguire SUBSTEP_CONFIG in financialPlannerWizard.js: 5 raccoglie i debiti
// (debt_status, mutuo, prestito, revolving), 6 le spese previste e 7 il lungo termine.
const STEP_KEYS = {
  1: 'situazione',
  2: 'entrate_spese',
  3: 'liquidita',
  4: 'fondo_emergenza',
  5: 'debiti',
  6: 'obiettivi',
  7: 'investimenti',
  8: 'riepilogo'
};

const COMPLETE_TRACKED_KEY = 'checkup_complete_tracked_v1';
const COMPLETE_TRACKED_MAX = 20;

let startSent = false;
const sentSteps = new Set();

function push(event, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

/** Impronta corta della compilazione: distingue un check-up dall'altro senza ricopiare i dati in chiaro. */
function fingerprint(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (Math.imul(hash, 31) + value.charCodeAt(i)) | 0;
  }
  return (hash >>> 0).toString(36);
}

/** True se questa compilazione era gia stata contata, anche in una visita precedente. */
function alreadyCounted(key) {
  try {
    const seen = JSON.parse(localStorage.getItem(COMPLETE_TRACKED_KEY) || '[]');
    if (seen.includes(key)) return true;
    localStorage.setItem(COMPLETE_TRACKED_KEY, JSON.stringify([...seen, key].slice(-COMPLETE_TRACKED_MAX)));
  } catch (error) { /* storage non disponibile: meglio un doppio evento che nessuno */ }
  return false;
}

/** Prima interazione col wizard: distingue chi lo apre davvero da chi rimbalza. */
export function trackCheckupStart() {
  if (startSent) return;
  startSent = true;
  push('checkup_start');
}

/** Avanzamento: è l'evento che disegna la curva di abbandono, schermata per schermata. */
export function trackCheckupStep(step, substepKey, progressPercent) {
  const id = `${step}:${substepKey}`;
  if (sentSteps.has(id)) return; // una sola volta per schermata: conta il raggiungimento, non i rimbalzi avanti/indietro
  sentSteps.add(id);
  push('checkup_step', {
    checkup_step: step,
    checkup_step_name: STEP_KEYS[step] || String(step),
    checkup_substep: `${step}_${substepKey}`,
    checkup_progress: Math.round(progressPercent)
  });
}

/** Ripresa da bozza salvata: dice se lo storage locale sta recuperando abbandoni. */
export function trackCheckupResume(step) {
  push('checkup_resume', { checkup_step: step });
}

/**
 * Completamento, con voto e livello: tasso di completamento + distribuzione della salute finanziaria.
 * I risultati vivono in un URL condivisibile (?d=<payload>), quindi rileggere la pagina o riaprire
 * il link contava come un nuovo completamento: si conta una volta sola per compilazione.
 */
export function trackCheckupComplete(score, level) {
  if (typeof window === 'undefined') return;
  if (alreadyCounted(fingerprint(`${score}:${level}:${window.location.search}`))) return;
  push('checkup_complete', {
    checkup_score: score,
    checkup_level: level
  });
}

/** Azioni sui risultati: pdf, condivisione, uso del calcolatore, riavvio. */
export function trackCheckupAction(action) {
  push('checkup_action', { checkup_action: action });
}
